import { render, staticRenderFns } from "./text-summary-1p1c.vue?vue&type=template&id=54c2a738&scoped=true&"
import script from "./text-summary-1p1c.vue?vue&type=script&lang=js&"
export * from "./text-summary-1p1c.vue?vue&type=script&lang=js&"
import style0 from "./text-summary-1p1c.vue?vue&type=style&index=0&id=54c2a738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c2a738",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VContainer,VFlex,VIcon,VImg,VLayout,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54c2a738')) {
      api.createRecord('54c2a738', component.options)
    } else {
      api.reload('54c2a738', component.options)
    }
    module.hot.accept("./text-summary-1p1c.vue?vue&type=template&id=54c2a738&scoped=true&", function () {
      api.rerender('54c2a738', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-dsm-application/result-components/text-summary-1p1c.vue"
export default component.exports